// extracted by mini-css-extract-plugin
export default {"emptyStatesContainer":"OAx03"};